// YG弹窗按钮WebComponent
class YGPopupButton extends HTMLElement {
  constructor() {
    super();
  }

  // 元素添加到DOM时调用
  connectedCallback() {
    this.render();
    this.bindEvents();
  }

  // 渲染组件
  render() {
    const button = this.querySelector('button');
  }

  // 绑定事件监听器
  bindEvents() {
    const button = this.querySelector('button');
    if (button) {
      button.addEventListener('click', this.handleClick.bind(this));
    }
  }

  // 处理点击事件
  handleClick(event) {
    event.preventDefault();
    // 查找全局的yg-popup元素
    const popup = document.querySelector('yg-popup');

    if (popup) {
      // 获取模板并插入到弹窗内容中
      const template = this.querySelector('template');
      if (template) {
        // 检查按钮是否为quiz按钮，需要特殊处理
        const button = this.querySelector('button');
        const isQuizButton = button && button.classList.contains('yg-quiz-button');

        if (isQuizButton) {
          // Quiz按钮：包含JS和CSS，需要特殊处理
          this.renderTemplateContentAsync(template, popup);
        } else {
          // 普通按钮：简单的HTML内容，直接克隆
          const content = template.content.cloneNode(true);
          const popupContent = popup.querySelector('.yg-popup-content');
          if (popupContent) {
            // 清空现有内容并添加新内容
            popupContent.innerHTML = '';
            popupContent.appendChild(content);
          }
          popup.open();
        }
      }
    }
  }

  // 异步渲染模板内容，包括处理script和style标签
  async renderTemplateContentAsync(template, popup) {
    const content = template.content.cloneNode(true);
    const popupContent = popup.querySelector('.yg-popup-content');

    if (!popupContent) return;

    // 显示加载状态
    this.showLoadingState(popupContent);

    try {
      // 分离script、style和link标签
      const scripts = [];
      const styles = [];
      const links = [];
      const otherElements = [];

      // 遍历所有子节点
      Array.from(content.children).forEach(child => {
        if (child.tagName === 'SCRIPT') {
          scripts.push(child);
        } else if (child.tagName === 'STYLE') {
          styles.push(child);
        } else if (child.tagName === 'LINK' && child.rel === 'stylesheet') {
          links.push(child);
        } else {
          otherElements.push(child);
        }
      });

      // 添加style标签到head
      styles.forEach(style => {
        // 检查是否已经存在相同的style
        const existingStyle = document.head.querySelector(`style[data-template-id="${this.getAttribute('id') || 'yg-popup'}"]`);
        if (existingStyle) {
          existingStyle.remove();
        }
        style.setAttribute('data-template-id', this.getAttribute('id') || 'yg-popup');
        document.head.appendChild(style);
      });

      // 添加link标签到head
      links.forEach(link => {
        // 检查是否已经存在相同的link
        const existingLink = document.head.querySelector(`link[href="${link.href}"]`);
        if (!existingLink) {
          link.setAttribute('data-template-id', this.getAttribute('id') || 'yg-popup');
          document.head.appendChild(link);
        }
      });

      // 异步加载和执行脚本
      await this.loadScriptsAsync(scripts);

      // 添加其他内容到弹窗
      popupContent.innerHTML = '';
      otherElements.forEach(element => {
        popupContent.appendChild(element);
      });

      // 打开弹窗
      popup.open();

    } catch (error) {
      console.error('加载模板内容时出错:', error);
      // 即使出错也要尝试显示内容
      popupContent.innerHTML = '';
      Array.from(content.children).forEach(child => {
        if (child.tagName !== 'SCRIPT') {
          popupContent.appendChild(child.cloneNode(true));
        }
      });
      popup.open();
    }
  }

  // 显示加载状态
  showLoadingState(popupContent) {
    popupContent.innerHTML = `
      <div class="yg-popup-loading">
        <div class="yg-loading-spinner"></div>
        <p>加载中...</p>
      </div>
    `;
  }

  // 异步加载脚本
  async loadScriptsAsync(scripts) {
    const loadPromises = scripts.map(script => {
      return new Promise((resolve, reject) => {
        // 检查是否已经存在相同的script
        const existingScript = document.head.querySelector(`script[src="${script.src}"]`);

        if (existingScript) {
          // 脚本已存在，检查是否已加载
          if (existingScript.loaded) {
            resolve();
          } else {
            // 等待脚本加载完成
            existingScript.addEventListener('load', () => resolve());
            existingScript.addEventListener('error', () => reject(new Error(`脚本加载失败: ${script.src}`)));
          }
          return;
        }

        if (script.src) {
          // 外部脚本
          const newScript = document.createElement('script');
          newScript.src = script.src;
          newScript.defer = script.defer || true;
          newScript.setAttribute('data-template-id', this.getAttribute('id') || 'yg-popup');

          newScript.addEventListener('load', () => {
            newScript.loaded = true; // 标记为已加载
            resolve();
          });

          newScript.addEventListener('error', () => {
            reject(new Error(`外部脚本加载失败: ${script.src}`));
          });

          document.head.appendChild(newScript);
        } else if (script.textContent) {
          // 内联脚本 - 立即执行
          try {
            eval(script.textContent);
            resolve();
          } catch (error) {
            reject(new Error(`内联脚本执行失败: ${error.message}`));
          }
        } else {
          resolve();
        }
      });
    });

    // 等待所有脚本加载完成
    await Promise.all(loadPromises);
  }
}

class YGPopup extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;

    // 防止重复绑定
    this._eventsBound = false;
    this._modelTabBound = false;

    // 记录当前 model-viewer
    this._modelViewer = null;
  }

  connectedCallback() {
    this.bindEvents();
  }

  // =========================
  // 基础事件绑定
  // =========================
  bindEvents() {
    if (this._eventsBound) return;
    this._eventsBound = true;

    // 关闭按钮事件
    const closeButton = this.querySelector(".yg-popup-close");
    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    // 点击背景关闭弹窗
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close();
      }
    });

    // ESC键关闭弹窗
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.isOpen) {
        this.close();
      }
    });
  }

  // =========================
  // 加载 model-viewer 脚本
  // =========================
  async loadModelViewerIfNeeded() {
    const popupContent = this.querySelector(".yg-popup-content");
    if (!popupContent) return;

    const hasModelViewer =
      popupContent.querySelector("model-viewer") ||
      popupContent.querySelector(".yg-3d-model-tab") ||
      popupContent.innerHTML.includes("model-viewer");

    if (!hasModelViewer) return;

    const existingScript = document.head.querySelector(
      'script[src*="model-viewer"]'
    );

    if (!existingScript) {
      await this.loadGoogleModelViewer();
    }

    // 脚本加载后缓存 model-viewer
    this._modelViewer = this.querySelector("model-viewer") || null;

    // 做 iOS 适配（必须在脚本加载后）
    if (this._modelViewer) {
      this.optimizeModelViewerForIOS(this._modelViewer);
      this.optimizeModelViewerForMobileTouch(this._modelViewer);
    }
  }

  async loadGoogleModelViewer() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      // 使用 Google 官方的 model-viewer 模块版本
      script.type = "module";
      script.src =
        "https://ajax.googleapis.com/ajax/libs/model-viewer/4.2.0/model-viewer.min.js";
        // "https://cdn.jsdelivr.net/npm/@google/model-viewer@3.4.0/dist/model-viewer.min.js";
      // 不加 data-template-id，避免被 cleanupTemplateResources 意外删除

      script.onload = () => {
        console.log("Google Model Viewer 脚本加载完成 (v3.4.0)");
        resolve();
      };

      script.onerror = () => {
        console.error("Google Model Viewer 脚本加载失败");
        reject(new Error("Google Model Viewer 脚本加载失败"));
      };

      document.head.appendChild(script);
    });
  }

  // =========================
  // Tab 切换逻辑
  // =========================
  bindModelTabEvents() {
    if (this._modelTabBound) return;

    const tabItems = this.querySelectorAll(".yg-3d-model-tab li");
    const modelViewer = this.querySelector("model-viewer");

    if (!tabItems.length || !modelViewer) return;

    this._modelTabBound = true;
    this._modelViewer = modelViewer;

    // 初始优化
    this.optimizeModelViewerForIOS(modelViewer);
    this.optimizeModelViewerForMobileTouch(modelViewer);

    tabItems.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabItems.forEach((item) => item.classList.remove("active"));
        tab.classList.add("active");

        const newUrl = tab.getAttribute("data-url");
        const newIosUrl = tab.getAttribute("data-ios-url");

        if (!newUrl && !newIosUrl) return;

        // 半透明表示加载中
        modelViewer.style.opacity = "0.5";

        // 重要：iOS 上一定要先 set ios-src 再 set src
        if (newIosUrl) {
          const finalIosUrl = newIosUrl.startsWith("https:")
            ? newIosUrl
            : "https:" + newIosUrl;

          modelViewer.setAttribute("ios-src", finalIosUrl);
        }

        if (newUrl) {
          const finalUrl = newUrl.startsWith("https:") ? newUrl : "https:" + newUrl;
          modelViewer.src = finalUrl;
        }

        // 绑定一次 load（防止重复绑定）
        modelViewer.addEventListener(
          "load",
          () => {
            modelViewer.style.opacity = "1";

            // iOS 上 load 后再做一次优化，避免某些情况下属性被覆盖
            this.optimizeModelViewerForIOS(modelViewer);

            if (this.isMobileDevice()) {
              setTimeout(() => {
                try {
                  modelViewer.focus();
                } catch (e) {}
              }, 80);
            }
          },
          { once: true }
        );
      });
    });
  }

  // =========================
  // iOS / Android AR 兼容性处理（核心修复）
  // =========================
  optimizeModelViewerForIOS(modelViewer) {
    const iOSVersion = this.getIOSVersion();
    const isIOS = iOSVersion !== null;

    if (!modelViewer) return;

    // iOS：只允许 quick-look
    if (isIOS) {
      // iOS 12 以下：Quick Look AR 基本不可用
      if (iOSVersion < 12) {
        modelViewer.removeAttribute("ar");
        modelViewer.setAttribute("ar-modes", "");
        console.log("iOS版本过低，已禁用AR功能:", iOSVersion);
        return;
      }

      // iOS 12+：只用 quick-look（不要 scene-viewer）
      modelViewer.setAttribute("ar-modes", "webxr scene-viewer quick-look");

      // 确保 ar 开启
      modelViewer.setAttribute("ar", "");

      // 防止某些情况下 quick-look 被覆盖
      // （比如你模板里写了 scene-viewer）
      console.log("iOS版本:", iOSVersion, "AR模式: quick-look");
      return;
    }

    // 非 iOS：Android 优先 scene-viewer/webxr
    // 这里写得更宽容
    modelViewer.setAttribute("ar", "");
    modelViewer.setAttribute("ar-modes", "webxr scene-viewer quick-look");
  }

  // =========================
  // 移动端触摸优化
  // =========================
  optimizeModelViewerForMobileTouch(modelViewer) {
    if (!modelViewer) return;
    if (!this.isMobileDevice()) return;

    // 注意：touch-action: none 会影响页面滚动
    // 如果你弹窗里不需要滚动，可以保留
    modelViewer.style.touchAction = "none";

    // 只阻止冒泡，不要 preventDefault
    modelViewer.addEventListener(
      "touchstart",
      (e) => {
        e.stopPropagation();
      },
      { passive: true }
    );

    modelViewer.addEventListener(
      "touchmove",
      (e) => {
        e.stopPropagation();
      },
      { passive: true }
    );
  }

  // =========================
  // 设备检测
  // =========================
  isMobileDevice() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) ||
      (window.innerWidth <= 768 && window.innerHeight <= 1024)
    );
  }

  getIOSVersion() {
    const userAgent = navigator.userAgent;
    const match = userAgent.match(/OS (\d+)_(\d+)(?:_(\d+))?/);

    if (match) {
      const major = parseInt(match[1], 10);
      const minor = parseInt(match[2], 10);
      const patch = match[3] ? parseInt(match[3], 10) : 0;

      // 返回更精确版本，比如 15.2.1
      return parseFloat(`${major}.${minor}${patch ? patch : ""}`);
    }

    return null;
  }

  // =========================
  // 打开 / 关闭
  // =========================
  async open() {
    this.isOpen = true;
    this.classList.add("open");
    document.body.style.overflow = "hidden";

    // 焦点陷阱
    try {
      this.focus();
    } catch (e) {}

    // 先加载脚本
    await this.loadModelViewerIfNeeded();

    // 再绑定 tab（确保 model-viewer 已存在）
    this.bindModelTabEvents();

    // 打开后如果已经有 model-viewer，确保 iOS 配置正确
    const mv = this.querySelector("model-viewer");
    if (mv) {
      this.optimizeModelViewerForIOS(mv);
    }
  }

  close() {
    this.isOpen = false;
    this.classList.remove("open");
    document.body.style.overflow = "";

    this.cleanupTemplateResources();
  }

  cleanupTemplateResources() {
    // 移除动态添加的script标签（包括3D相关的脚本）
    // ⚠️ 注意：如果你页面其它地方也用了 model-viewer，移除脚本会导致其它地方炸
    // 如果你站点全局都需要 model-viewer，建议不要 remove script
    const scripts = document.head.querySelectorAll("script[data-template-id]");
    scripts.forEach((script) => {
      const src = script.getAttribute("src") || "";
      // 保留 Shopify model-viewer 脚本，避免重复加载导致 iOS AR 出现兼容性问题
      if (src.includes("shopifycloud/model-viewer")) return;
      script.remove();
    });
  }
}

// DOM加载完成后初始化WebComponents
document.addEventListener('DOMContentLoaded', () => {
  if (!window.customElements.get('yg-popup-button')) {
    window.customElements.define('yg-popup-button', YGPopupButton);
  }

  if (!window.customElements.get('yg-popup')) {
    window.customElements.define('yg-popup', YGPopup);
  }
});
